import {
  BRAND_MARK_PATH_LEFT,
  BRAND_MARK_PATH_RIGHT,
  BRAND_MARK_PATH_SIMPLE,
  BRAND_MARK_VIEWBOX,
  markStrokeWidth,
  simpleMarkStrokeWidth,
  squareRadius,
  usesSimpleMark,
} from '@icebreaker/shared/design';
import styles from './brand-mark.module.css';

/**
 * MARKA İŞARETİ — "Kırık W" (marka sözleşmesi §2/§3/§4).
 *
 * Neden `<img src={logoLightUrl}>` DEĞİL: kontur kalınlığı BOYA GÖRE değişir
 * (§2 tablosu) ve 18 px altında çizim TAMAMEN başkalaşır (basit W). Tek bir
 * SVG dosyasını ölçeklemek 16 px'te işareti bulanık bir lekeye çevirirdi.
 * Dosyalar (`public/brand/*.svg`) dış tüketiciler içindir — e-posta, OG,
 * favicon, üçüncü taraf. Arayüz işareti BURADAN çizilir.
 *
 * Renk bileşene SABİTLENMEZ: üç renk `--ib-mark-*` / `--ib-mark-band-*`
 * değişkenlerinden gelir (`tokens.css.ts` → `brandMarkColors`).
 */
export type BrandMarkTone =
  /** Yüzey üstü — temayla döner (açık zemin ↔ karanlık tema varyantı). */
  | 'surface'
  /** İnk bant içi — ters çevrilmiş: kare açılır, işaret ink olur. */
  | 'band'
  /** Tek renk, karesiz; rengi `currentColor`dan alır (damga, baskı, mono). */
  | 'mono';

export interface BrandMarkProps {
  /** Çizim boyu (px). Kontur ve köşe bundan türer; §4 asgarileri geçerlidir. */
  readonly size: number;
  readonly tone?: BrandMarkTone;
  /** Kareyi bastırır (mono zaten karesizdir). */
  readonly square?: boolean;
  readonly className?: string;
}

export function BrandMark({ size, tone = 'surface', square = true, className }: BrandMarkProps) {
  const mono = tone === 'mono';
  const simple = mono || usesSimpleMark(size);
  const withSquare = square && !mono;
  const stroke = simple ? simpleMarkStrokeWidth(size) : markStrokeWidth(size);
  /*
   * ÖN EK `--ib-mark-`tir, `--ib-brand…` DEĞİL: ikinci ad alanı ETKİNLİK ve
   * KURUM markasına aittir (devralım zinciri; envanter kapısı onu denetler).
   * Platformun işareti AYRI katmandır (karar P8); iki ad alanı karışırsa o
   * kapı — doğru biçimde — kırılır.
   */
  const prefix = tone === 'band' ? '--ib-mark-band' : '--ib-mark';
  const inkColor = mono ? 'currentColor' : `var(${prefix}-ink)`;
  const accentColor = mono ? 'currentColor' : `var(${prefix}-accent)`;

  return (
    <svg
      className={[styles.mark, className].filter(Boolean).join(' ')}
      width={size}
      height={size}
      viewBox={`0 0 ${BRAND_MARK_VIEWBOX} ${BRAND_MARK_VIEWBOX}`}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {withSquare ? (
        <rect
          width={BRAND_MARK_VIEWBOX}
          height={BRAND_MARK_VIEWBOX}
          rx={squareRadius(size)}
          fill={`var(${prefix}-square)`}
        />
      ) : null}
      {simple ? (
        <path
          d={BRAND_MARK_PATH_SIMPLE}
          stroke={inkColor}
          strokeWidth={stroke}
          strokeLinejoin="miter"
        />
      ) : (
        <>
          <path
            d={BRAND_MARK_PATH_LEFT}
            stroke={inkColor}
            strokeWidth={stroke}
            strokeLinecap="square"
          />
          <path
            d={BRAND_MARK_PATH_RIGHT}
            stroke={accentColor}
            strokeWidth={stroke}
            strokeLinecap="square"
          />
        </>
      )}
    </svg>
  );
}
